module.exports = __webpack_public_path__ + "static/media/futura-std-bold.5adf5e8f.woff";